import type { FCC } from '../../../../types';

export const EmptyMessage: FCC = ({ children }) => {
    return <div className={'p-1 text-center font-medium dark:bg-gray-dark-500 dark:text-white'}>{children}</div>;
};